import { formatBoolean } from "../../../../utils/field-types-helper";

function InputBooleanReadOnly({ value, className }) {
  return <div className={className}>{formatBoolean(value)}</div>;
}

export default InputBooleanReadOnly;
